import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get purchaseInvoiceBranch
export const getPurchaseInvoiceBranch = createAsyncThunk(
  "purchaseInvoiceBranch/getPurchaseInvoiceBranch",
  async (params, { rejectWithValue }) => {
    const { rowsPerPage, search, sortOrder, pageNo } = params;
    try {
      const { data } = await API.getPurchaseInvoiceBranch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all purchaseInvoiceBranch
export const getAllPurchaseInvoiceBranch = createAsyncThunk(
  "purchaseInvoiceBranch/getAllPurchaseInvoiceBranch",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllPurchaseInvoiceBranch();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk(
  "purchaseInvoiceBranch/getPrevious",
  async (previous, { rejectWithValue }) => {
    try {
      const { data } = await API.getPrevious(previous);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get next
export const getNext = createAsyncThunk("purchaseInvoiceBranch/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "purchaseInvoiceBranch/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPagePurchaseInvoiceBranch({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getPurchaseInvoiceBranchById = createAsyncThunk(
  "purchaseInvoiceBranch/getPurchaseInvoiceBranchById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseInvoiceBranchById(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getPurchaseOrderDetail = createAsyncThunk(
  "purchaseInvoiceBranch/getPurchaseOrderDetail",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getPurchaseOrderDetail(id);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create purchaseInvoiceBranch
export const createPurchaseInvoiceBranch = createAsyncThunk(
  "purchaseInvoiceBranch/createPurchaseInvoiceBranch",
  async (createData, { rejectWithValue }) => {
    const {
      purchaseInvoiceFromBranch,
      branch,
      voucherDateBs,
      voucherDate,
      purchaseInvoiceDetail,
      purchaseOrderMain,
      discountAmount,
      grandTotal,
      vatAmount,
    } = createData;
    try {
      const body = JSON.stringify({
        purchaseInvoiceFromBranch,
        branch,
        voucherDateBs,
        voucherDate,
        purchaseInvoiceDetail,
        purchaseOrderMain,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.createPurchaseInvoiceBranch(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updatePurchaseInvoiceBranch = createAsyncThunk(
  "purchaseInvoiceBranch/updatePurchaseInvoiceBranch",
  async (data, { rejectWithValue }) => {
    const { id, values } = data;
    const {
      salesOrder,
      indentNo,
      isFromHo,
      requiredDateAd,
      voucherDateBs,
      voucherDate,
      branch,
      status,
      documentsAttach,
      discountAmount,
      grandTotal,
      vatAmount,
      // refVoucher,
      purchaseInvoiceBranchDetails,
    } = values;
    try {
      const body = JSON.stringify({
        salesOrder,
        indentNo,
        isFromHo,
        requiredDateAd,
        branch,
        status,
        voucherDateBs,
        voucherDate,
        // refVoucher,
        purchaseInvoiceBranchDetails,
        discountAmount,
        grandTotal,
        vatAmount,
      });
      const { data } = await API.updatePurchaseInvoiceBranch(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk(
  "purchaseInvoiceBranch/handleSearch",
  async ({ rowsPerPage, search, sortOrder, pageNo }, { rejectWithValue }) => {
    try {
      const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
